var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"columns-list"},_vm._l((_setup.props.columns),function(group){return _c(_setup.ColumnsGroup,{key:group.name,attrs:{"group":group}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }